import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const WelcomePageForAdTracking = () => {
    const navigate = useNavigate();

  useEffect(() => {
    navigate('/get-started', { replace: true });
  }, [navigate]);

  return null;

}
export default WelcomePageForAdTracking;